
























import { Component, Provide, Watch, Vue } from "vue-property-decorator";
import moment from "moment";

@Component({  
  props: ["rows"]
})
export default class HistoryGrid extends Vue {  
  moment = moment;
};
